<template>
  <div class="messageSet">
    <div class="commonBg"></div>
    <div class="uploadPage_toptitle">
      <div class="uploadPage_toptitlebox">
        <van-icon name="arrow-left" @click="back" />
        <div class="details_top_title">消息设置</div>
        <van-icon name="close" v-show="
          $store.state.system == 'android' &&
          applets != 'xcx' &&
          !$store.state.isXcx &&
          $store.state.isInGame
        " @click="closeCommunity" />
        <!-- <van-icon name="close" /> -->
      </div>
    </div>
    <div class="messageSet_con">
      <div class="messageSet_con_prompt">打开后将推送相应类型消息</div>
      <div class="messageSet_con_list" v-for="item in list" :key="item.id">
        <div>{{ item.name }}</div>
        <van-switch v-model="item.checked" @click="switchClick(item)" />
      </div>
    </div>
  </div>
</template>
<script>
import get from '../../../../api/get';
import qs from 'qs';
import { Toast } from 'vant';
import * as _code from '../../../../utils/code';
export default {
  name: 'messageSet',
  data() {
    return {
      applets: window.user.weixcode ? "xcx" : "",
      list: [
        { id: 0, name: '回复', checked: false, text: 'receiveReply' },
        { id: 1, name: '表态', checked: false, text: 'receiveSns' },
        { id: 2, name: '关注', checked: false, text: 'receiveFollow' }
      ]
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      get.queryMessageSet().then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.list[0].checked = data.data.receiveReply == 1 ? true : false;
          this.list[1].checked = data.data.receiveSns == 1 ? true : false;
          this.list[2].checked = data.data.receiveFollow == 1 ? true : false;
        } else {
          this.errorMessage(data.code);
        }
      });
    },
    switchClick(item) {
      item.checked = !item.checked;
      let obj = {};
      obj[item.text] = item.checked ? 1 : 0;
      get.updateMessageSet(qs.stringify(obj)).then((res) => {
        let data = res.data;
        if (data.code == 0) {
        } else {
          this.errorMessage(data.code);
        }
      });
    },
    back() {
      this.$emit('changePage', 0);
    },
    closeCommunity() {
      window.pd.onBBSClose();
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    }
  }
};
</script>
<style scoped></style>